// 仓库配置文件
import { createPinia } from 'pinia';

const state = createPinia();

export default state;

export * from './modules/base.js';
